<template>
  <div class="minimal-drop-down">
    <div ref="parent" class="block dd-contents" @click="toggleDropDown()">
      <p class="selected">
        {{ value ? (value.name ? value.name : placeholder) : placeholder }}
      </p>
      <i class="material-icons drop-down-icon">arrow_drop_down</i>
    </div>
    <div
      v-show="isDropped"
      ref="options"
      :class="['options', 'shadow-down', { dropup: dropup }]"
    >
      <div
        class="option"
        v-for="option in options"
        :key="option.id"
        @click="selectItem(option)"
      >
        <p class="ellipsis">{{ option.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: String,
    options: Array,
    value: Object || String,
    dropup: Boolean,
  },
  data: () => ({
    selected: {
      id: "",
      name: "",
    },
    isDropped: false,
  }),
  methods: {
    toggleDropDown() {
      this.isDropped = !this.isDropped;
    },
    closeDropDown() {
      this.isDropped = false;
    },
    removeListener() {
      this.closeDropDown();
      document.removeEventListener("click", this.removeListener, false);
    },
    selectItem(option) {
      this.isDropped = false;
      this.selected = option;
      this.$emit("input", option);
    },
  },
  watch: {
    isDropped(value) {
      if (value) {
        setTimeout(() => {
          document.addEventListener("click", this.removeListener);
        }, 200);
      }
    },
  },
  mounted() {
    // const parent = this.$refs.parent;
    // const options = this.$refs.options;
    // options.style.width = `${parent.offsetWidth}px`;
    // const { top, bottom, left } = parent.getBoundingClientRect();
    // console.log(top, bottom, left);
    // console.log(parent.parentElement.getBoundingClientRect());
    // if (!this.dropup) {
    //   options.style.top = `${top + 45}px`;
    //   options.style.left = `${left}px`;
    // } else {
    //   options.style.bottom = `${bottom - 25}px`;
    //   options.style.left = `${left}px`;
    // }
  },
};
</script>

<style lang="scss" scoped>
.minimal-drop-down {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 0;
  background-color: var(--color-secondary);
  border-radius: 30px;
  transition: 0.3s all ease-in-out;

  .dd-contents {
    display: block;
    position: relative;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background: var(--color-default-background);
    width: 100%;
    border: 1px solid var(--border-color);
    border-radius: 5px;
    transition: 0.3s all ease-in-out;

    &:hover {
      border: 1px solid var(--color-accent);
      cursor: pointer;
    }
  }

  i {
    position: absolute;
    right: 10px;
    bottom: 9px;
  }

  .options {
    position: absolute;
    width: 100%;
    background: var(--color-secondary);
    z-index: 999;
    max-height: 300px;
    overflow: auto;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    top: 45px;

    &.dropup {
      top: auto !important;
      bottom: 50px !important;
    }

    &:last-child {
      border-bottom: 0 !important;
    }
    .option {
      border-bottom: 1px solid var(--border-color);
      padding: 10px;

      &:hover {
        background-color: var(--border-color);
        cursor: pointer;
      }

      p {
        margin: 0;
      }
    }
  }

  .selected {
    border-bottom: 0;
    padding: 10px 25px 10px 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    transition: 0.2s all ease-in-out;

    &:hover {
      border-bottom: 0;
      cursor: pointer;
    }
  }
}
</style>
